<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>Submit Preferred Site Visit Dates?</h2>
    <p>
      This action will send your preferred site visit dates.
      <br />
      <br />
      Do you wish to continue?
    </p>
    <br />
    <div class="documents-dialog__content__footer">
      <div class="documents-dialog__content__footer__service-type">
        <div class="documents-dialog__content__footer__service-type__label">
          Service Type
        </div>
        <div class="service-type">
          {{ siteSubType ? siteType + " - " + siteSubType : siteType }}
        </div>
      </div>
      <div class="documents-dialog__content__footer__service-type">
        <div class="documents-dialog__content__footer__service-type__label">
          Location
        </div>
        <div class="location">
          <span *ngIf="address.streetAddress"
            >{{ address.streetAddress }}<br /></span
          >{{ address.cityStateZip }}
        </div>
      </div>
      <div class="btnalign">
        <button
          class="documents-dialog__content__footer__submit pull-right"
          (click)="submit()"
          [disabled]="isSubmitting"
        >
          Submit
        </button>
        <button class="defaultbtn" (click)="closeDialog()">Back</button>
      </div>
    </div>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
